// extracted by mini-css-extract-plugin
export default {"headerTitleWrap":"HeaderTitle_headerTitleWrap__+GurG","title":"HeaderTitle_title__9ySRZ","version":"HeaderTitle_version__F6SaM"};